import { SELECTED_TEST, SET_RESULTS } from "../constants/testConstants";

const initialResultState = {
  // Define your initial result state here
};

const initialTestSelectedState = {
  // Define your initial test selected state here
};

// Get initial auth state from localStorage if available
const initialAuthState = {
  user: JSON.parse(localStorage.getItem('user')) || null
};

export const testSelectedReducer = (state = initialTestSelectedState, action) => {
  switch (action.type) {
    case SELECTED_TEST:
      return { title: action.payload };
    default:
      return state;
  }
};

export const resultReducer = (state = initialResultState, action) => {
  switch (action.type) {
    case SET_RESULTS:
      return { result: action.payload };
    default:
      return state;
  }
};

export const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload };
    default:
      return state;
  }
};
